import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

// Axios Request
import { fetchSinglePost } from '../requests/singlepost_request';

//components
import Header from '../components/Header';
import Loader from '../components/Loader';
import RenderSingle from '../components/Pages/RenderSingle';
import Section from '../components/Pages/About/Section';
import Partner from '../components/Pages/About/Partner';
import ReadMore from '../components/Pages/ReadMore';
import Footer from '../components/Footer';

import Slider from 'react-slick';

//assets
import spiraal from '../images/spiraal.gif';
import bak from '../images/bak.gif';
import pinball from '../images/pinball.gif';
import bom from '../images/bom.gif';

class SinglePageAbout extends Component {
    state = {
        scrollToPartner: false,
    };
    constructor(props) {
        super(props);
        this.targetRef = React.createRef();
    }

    componentDidMount() {
        document.title = `About - Friends for Brands`;
        window.scrollTo(0, 0);

        if (this.props.location.state) {
            setTimeout(() => {
                this.targetRef.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 500);
        }
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        let slug = this.props.match.path;

        slug = slug.substring(1);
        if (willMount) {
            this.props.fetchSinglePost('pages', slug);
        }
    }

    // Slick Slider - About Page
    slickSlider() {
        const { quote_slider: slides } = this.props.posts.posts[0].acf;

        const settings = {
            dots: true,
            infinite: false,
            autoPlay: true,
            autoplaySpeed: 1000,
            speed: 500,
            slidesToShow: 1,
            verticalSwiping: true,
            arrows: false,
            slidesToScroll: 1,
        };

        const handleNext = () => {
            this.slider.slickNext();
        };

        const handlePrevious = () => {
            this.slider.slickPrev();
        };

        const SlideArrows = () => (
            <div className="about__slider--navigation">
                <button className="button prev" onClick={handlePrevious}>
                    <i className="icon icon-arrow_right" />
                </button>
                <button className="button next" onClick={handleNext}>
                    <i className="icon icon-arrow_right" />
                </button>
            </div>
        );

        const AboutSlider = () => {
            return (
                <Slider ref={(slider) => (this.slider = slider)} {...settings}>
                    {slides.map((value, index) => (
                        <div
                            ref={this.slides}
                            className={`slide-item slick-slide-${index}`}
                            key={index}>
                            <div className="inner-container">
                                <h2>{ReactHtmlParser(value.quote_slide)}</h2>
                            </div>
                        </div>
                    ))}
                </Slider>
            );
        };

        return (
            slides && (
                <div className="about__slider">
                    <div className="fadeIn">
                        <div className="content-container">
                            <AboutSlider />
                        </div>
                        <SlideArrows />
                    </div>
                </div>
            )
        );
    }

    render() {
        let GET_THE_POSTS = this.props.posts;
        let DID_FETCH = GET_THE_POSTS.fetched;
        let ACF_FIELD = DID_FETCH && GET_THE_POSTS.posts[0].acf;

        // Sections
        const TheContent = () => {
            const sections = [
                {
                    current_index: 1,
                    is_inversed: true,
                    title: ACF_FIELD.howwework_purpose,
                    content: ACF_FIELD.howwework_purpose_text,
                    expertises: ACF_FIELD.howwework_expertises_purpose,
                    image_url: spiraal,
                    image_alt: ACF_FIELD.howwework_purpose,
                },

                {
                    current_index: 2,
                    is_inversed: false,
                    title: ACF_FIELD.howwework_socialimpact,
                    content: ACF_FIELD.howwework_socialimpact_text,
                    expertises: ACF_FIELD.howwework_expertises_socialimpact,
                    image_url: bak,
                    image_alt: ACF_FIELD.howwework_socialimpact,
                },

                {
                    current_index: 3,
                    is_inversed: true,
                    title: ACF_FIELD.howwework_creatiefconcept,
                    content: ACF_FIELD.howwework_creatiefconcept_text,
                    expertises: ACF_FIELD.howwework_expertises_creatiefconcept,
                    image_url: pinball,
                    image_alt: ACF_FIELD.howwework_creatiefconcept,
                },

                {
                    current_index: 4,
                    is_inversed: false,
                    title: ACF_FIELD.howwework_activation,
                    content: ACF_FIELD.howwework_activation_text,
                    expertises: ACF_FIELD.howwework_expertises_activation,
                    image_url: bom,
                    image_alt: ACF_FIELD.howwework_activation,
                },
            ];

            return (
                DID_FETCH &&
                ACF_FIELD &&
                sections.map((field, index) => (
                    <div className="about--block" key={field.current_index}>
                        <Section
                            key={field.current_index}
                            inverseRow={field.is_inversed}
                            title={field.title}
                            content={field.content}
                            expertises={field.expertises}
                            src={field.image_url}
                            alt={field.image_alt}
                        />
                    </div>
                ))
            );
        };

        return (
            <div className="about page">
                <Header />
                <main>
                    <Loader loaded={DID_FETCH} />
                    <article className="about__intro">
                        <div className="content-container">
                            <div className="fadeIn">
                                <RenderSingle posts={GET_THE_POSTS} />
                            </div>
                        </div>
                    </article>

                    {DID_FETCH && ACF_FIELD && this.slickSlider()}

                    <section id="how-we-work">
                        <div className="fadeIn">
                            <div className="content-container">
                                <h2>How we work</h2>
                            </div>
                            <TheContent />
                        </div>
                    </section>
                    <div
                        ref={(ref) => {
                            this.targetRef = ref;
                        }}>
                        <Partner
                            title={ACF_FIELD.partner_title}
                            content={ACF_FIELD.partner_over}
                        />
                    </div>
                    <div className="inner-container">
                        <ReadMore
                            moreLeft={ACF_FIELD.readmore_left}
                            moreRight={ACF_FIELD.readmore_right}
                        />
                    </div>
                    <Footer type="about" />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(SinglePageAbout)
);



// WEBPACK FOOTER //
// ./src/containers/SinglePageAbout.jsx